<template>
  <div class="works_list_selector">
    <div v-show="start_mode == true" class="title_wrapper input_wrapper">
      <div class="left_title" v-if="false">
        <b-button class="title_white_button title_text_button select_all" variant="outline-secondary" size="sm" pill @click="selectAll"
          >{{ $t("select_all") }}</b-button
        >
        <b-button class="title_white_button title_text_button" variant="outline-secondary" size="sm" pill @click="deselectAll"
          >{{ $t("deselect_all") }}</b-button
        >
      </div>
      <div class="stock_title_holder">
        <div class="stock_title_text">{{ $t("common.works") }}</div>
        <b-button class="title_white_button" variant="outline-secondary" size="sm" pill @click="showFilters"
          ><img src="@/assets/images/icons/options.svg"
        /></b-button>
      </div>
    </div>
    <works
      ref="worksModuleWL"
      @setStartMode="setStartMode"
      @showToastMessage="
        (type, message) => {
          this.$emit('showToastMessage', type, message);
        }
      "
      @setParentShowAddArticle="setParentShowAddArticle"
      @showCellLayerMaps="() => {}"
      @setShowFilterText="setShowFilterText"
      :showFilterText="showFilterText"
      :start_mode="start_mode"
      usage_mode="LIGHT"
      @onDataLoadFinished="onDataLoadFinished"
      :edit-mode-enabled="editModeEnabled"
      :workListFilters="workListFilters"
      :parcelNameWithUnitAndLegalEntity="true"
      :showFuelConsumption="false"
    ></works>
    <filters-dialog
      ref="filterDialogWL"
      @applyFilters="applyFilters"
      :showPopup="showFiltersDialog"
      @hidden="hideFilters"
      @onDataLoading="onDataLoading"
      :api-config="null"
      :groupFilterVisible="false"
      :productFilterVisible="false"
      @onFiltersReady="resetFilters"
    ></filters-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Works from "@/pages/works/applyArticles/partials/works.vue";
import FiltersDialog from "@/pages/works/applyArticles/dialogs/filters";

export default {
  name: "WorkListSelector",
  props: {
  },
  data() {
    return {
      loading: false,
      start_mode: true,
      form_mode: "new",
      showFiltersDialog: false,
      workListFilters: {
        departments: [],
        date_from: "",
        date_to: "",
        works: [],
        machines: [],
        parcels: [],
        products: [],
        season: [],
        src: null,
        group_by: "work",
      },
      showFilterText: false,
      addArticleShowing: false,
      editModeEnabled: false,
    };
  },
  validations() {
    return {};
  },
  components: {
    Works,
    FiltersDialog,
  },
  computed: {
    ...mapGetters({
      departments: "company/departments",
    }),
  },
  watch: {},
  methods: {
    selectAll() {
      this.$refs.worksModuleWL.selectAll();
    },
    deselectAll() {
      this.$refs.worksModuleWL.deselectAll();
    },
    onDataLoadFinished(state) {
      this.loading = false;
    },
    showFilters() {
      this.showFiltersDialog = true;
    },
    hideFilters() {
      this.showFiltersDialog = false;
    },
    applyFilters(filters) {
      this.deselectAll();
      this.$set(this, "workListFilters", filters);
      this.$refs.worksModuleWL.applyFilters(filters);
      this.hideFilters();
    },
    resetFilters() {
      this.deselectAll();
      this.$refs.filterDialogWL.setInitFilters({
        departments: this.departments.map((d) => d.uuid),
        date_from: "",
        date_to: "",
        works: [],
        machines: [],
        parcels: [],
        products: [],
        seasons: [],
        group_by: "work",
      });
      this.applyFilters({
        departments: this.departments.map((d) => d.uuid),
        date_from: "",
        date_to: "",
        works: [],
      });
    },
    setStartMode(newVal) {
      this.start_mode = newVal;
    },
    setParentShowAddArticle(newVal) {
      this.addArticleShowing = newVal;
    },
    setShowFilterText(newVal) {
      this.showFilterText = newVal;
    },
    onDataLoading(state) {
      this.loading = state;
    },
    async getSelectedItems() {
      return await this.$refs.worksModuleWL.getSelectedItems();
    },
    fillWorkList() {
      this.$refs.worksModuleWL.fillWorkList(null);
    },
  },
  mounted() {
    this.fillWorkList();
  },
};
</script>

<style lang="scss">
/*.works_list_selector .list_wrapper {
  margin-top: 5px !important;
}*/

@import "@/assets/scss/digitalAgenda/daGrid.scss";

.list_wrapper {
    height: calc(100vh - 200px) !important;
    margin-top: 10px !important;
}
</style>

<style scoped>
.works_list_selector .left_title .select_all {
  margin-left: 0px !important;
}

.works_list_selector .title_wrapper {
  padding-top: 0px !important;
  margin-bottom: 0px !important;
}

.works_list_selector .stock_title_holder {
  padding-top: 0px !important;
}
</style>
